'use strict';

var base = require('base/product/base');

/**
 * Updates the quantity DOM elements post Ajax call
 * @param {updateAddToCartButtonStatus[]} product -  The number of products to purchase
 */

function updateAddToCartButtonStatus(data, $selector, $selector2) {
    if (!data.isProductOrderable.orderable) {
        $selector.html(data.isProductOrderable.errorMessage);
        $selector.prop('disabled', true);
        $selector2.prop('disabled', true);
        $selector.addClass('my-account-revamp-disabled');
    }
}

module.exports = {
    addToCart: function () {
        $('.cta-add-to-cart').on('click', function() {
            $.spinner().start();
            var $button = $(this);
            var $button2 = $('#renew-order');
            var pid = $(this).data('pid');
            var url = $('.add-to-cart-url').val();
            var form = {
                pid: pid,
                quantity: 1
            };
            $.ajax({
                url: url,
                method: 'POST',
                data: form,
                success: function(response) {
                    $('.minicart').trigger('count:update', response);
                    base.miniCartReportingUrl(response.reportingURL);
                    $('#cartquantity').text(response.quantityTotal);
                    updateAddToCartButtonStatus(response, $button, $button2);
                    $('.minicart-link-desktop').trigger('click');
                    $('.minicart-link-mobile').trigger('click');
                    $.spinner().stop();
                },
                error: function(xhr, status, error) {
                    console.error('Error adding product to cart:', error);
                    $.spinner().stop();
                }
            });
        });
    },

    renewOrder: function () {
        $('.re-order-cta').on('click', function() {
            $.spinner().start();
            var orderID = $(this).data('order-id');
            var url = $(this).data('url');
            $.ajax({
                url: url,
                type: 'POST',
                data: {orderID: orderID},
                success: function(response) {
                    if (response.success) {
                        base.miniCartReportingUrl(response.reportingURL);
                        $.spinner().stop();
                        window.location = response.redirectUrl;
                    }
                },
                error: function() {
                    console.error('There was an error processing your request.');
                    $.spinner().stop();
                }
            });
        });
    },

    invoice: function () {
        $('.js-invoice-link-button-revamp').click(function (e) {
            e.preventDefault();
            $(this).attr('aria-pressed', true);
            $.spinner().start();
        
            $.ajax({
                url: $(this).attr('action'),
                type: 'POST',
                dataType: 'json',
                success: function (data) {
                    if (data.invoiceUrl && data.invoiceName) {
                        download(data.invoiceUrl, data.invoiceName);
                    }
                    if (data.invoiceInfo) {
                        download(data.invoiceInfo.invoiceData, data.invoiceInfo.invoiceName);
                    }
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });

        //for Print only
        if ($('#printThis').length) {
            $(document).on('click', '#btnPrint', function () {
                window.print();
            })
            $(document).on('click', '.close', function () {
                $('#modalInvoicePDF').modal('hide');
                $('#modalInvoicePDF').hide();
            })
        }
    }
};

var download = (dataUrl, filename) => {
    var link = document.createElement('a');
    link.href = dataUrl;
    link.download = filename;
    link.click();
};